import React from "react";
import axios from "axios";
import { Divider, message, Select, Space } from "antd";
import { useState, useEffect } from "react";

import { PAYMENT_GATEWAYS } from "../../constants/paymentGateways";

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";

const UserPreferences = ({ merchantId, currentPreferences }) => {

  console.log("currentPreferences : ", currentPreferences)
  const { permissions } = usePermissions();
  const [preferences, setPreferences] = useState(currentPreferences || {});
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    setDisabled(!permissions?.includes(PERMISSIONS.UPDATE_BETA_FEATURES));
  }, [permissions]);

  const onChange = async (preferences) => {

    console.log("ON CHANGES : ", preferences)
    setPreferences(preferences);

    try {
      await axios.put(`/api/merchants/${merchantId}/preferences`, preferences);

      message.info("Updated");
    } catch (err) {
      message.error("Error when updating User Preferences.");
    }
  };

  return (
    <>
      <Divider />
      <Space direction="vertical" size="middle">
        <div>
          Top Up Payment Gateway:
          <Select
            placeholder="Default"
            allowClear
            style={{ width: 200, marginLeft: 10 }}
            disabled={disabled}
            value={preferences.paymentGateway}
            onChange={(paymentGateway) => onChange({ paymentGateway })}
          >
            {Object.entries(PAYMENT_GATEWAYS).map(([key, gateway]) => (
              <Select.Option key={gateway.key} value={gateway.key}>
                {gateway.label}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          Payout Payment Gateway:
          <Select
            placeholder="Default"
            allowClear
            style={{ width: 200, marginLeft: 10 }}
            disabled={disabled}
            value={preferences.payoutPaymentGateway}
            onChange={(payoutPaymentGateway) => onChange({ payoutPaymentGateway })}
          >
            {Object.entries(PAYMENT_GATEWAYS).map(([key, gateway]) => (
              <Select.Option key={gateway.key} value={gateway.key}>
                {gateway.label}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Space>
    </>
  );
};

export default UserPreferences;
